var map = {
	"./en-US.json": [
		25381,
		3963
	],
	"./es-ES.json": [
		39480,
		9814
	],
	"./pt-BR.json": [
		46040,
		3998
	],
	"./vi-VN.json": [
		98871,
		5413
	],
	"./zh-CN.json": [
		731,
		6985
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 79842;
module.exports = webpackAsyncContext;